import { get } from "app/main/functions.ts";

export const placeTagmanagerScript = (GTM_ID: string) => {
    const tagmanagerScript = document.createElement("script");
    tagmanagerScript.type = "application/javascript";
    tagmanagerScript.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(tagmanagerScript);
};

export const setPageCategoryLevel = (path: string) => {
    const array: any = [];
    if (path === "") {
        return array;
    }
    const preparedPath = `Home${path}`.split("/");
    const categoryMapping: { [key: string]: string } = {
        finanzen: "Wirtschaft & Finanzen",
        boerse: "Börse & Märkte"
    };

    preparedPath.forEach((item: string, index: number) => {
        const arrayKey = `pageCategoryLevel${index + 1}`;
        const category = categoryMapping[item] ? categoryMapping[item] : item;
        array[arrayKey] = category;
    });

    return array;
};

export const getTonlineBrowserInformation = (): [string, string] => {
    let vidArr: [string, string] = ["unknown", "unknown"];
    if (navigator.userAgent.match(/TOB(.(\d|\.|_)*)/)) {
        vidArr = get(navigator, "userAgent.match(/TOB(.(\\d|\\.|_)*)/)[1]", "").split("_");
    }
    return vidArr;
};

export const isLive = () => location.href.startsWith("https://www.t-online");

interface Query {
    isin?: string;
    newsId?: string;
    analysisId?: string;
}

export const queryContentID = (query: Query): string => {
    if (!query) {
        return "";
    }

    if (query.analysisId) {
        return query.analysisId;
    }
    if (query.newsId) {
        return query.newsId;
    }
    if (query.isin) {
        return query.isin;
    }
    return "";
};

export const queryContentType = (query: Query): string => {
    if (query && (query.analysisId || query.newsId)) {
        return "Article";
    }
    return "Page";
};
